require("./main.ts");



//////////////////
// WEBPACK FOOTER
// ./django/project/@static/@modules/related-posts-slider/index.js
// module id = 81
// module chunks = 8